// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../../scalars/Scalars.bs.js");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var ReactRender = require("../../../reason/utils/ReactRender.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
var InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarkPropertyAsSoldDialogMutation_graphql = require("../../../__generated__/MarkPropertyAsSoldDialogMutation_graphql.bs.js");

var convertVariables = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertVariables;

var convertResponse = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MarkPropertyAsSoldDialogMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarkPropertyAsSoldDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, MarkPropertyAsSoldDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var MarkPropertyAsSoldMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function MarkPropertyAsSoldDialog(props) {
  var close = props.close;
  var propertyId = props.propertyId;
  var match = use();
  var mutate = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setComment = match$1[1];
  var comment = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setSoldPrice = match$2[1];
  var soldPrice = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setHideSoldPrice = match$3[1];
  var hideSoldPrice = match$3[0];
  var match$4 = React.useState(function () {
        return "Idle";
      });
  var setSubmissionStatus = match$4[1];
  var submissionStatus = match$4[0];
  var resetForm = function () {
    setSubmissionStatus(function (param) {
          return "Idle";
        });
    setComment(function (param) {
          return "";
        });
    setSoldPrice(function (param) {
          
        });
    setHideSoldPrice(function (param) {
          return false;
        });
  };
  var handleMarkingSoldSuccess = function () {
    close();
    resetForm();
  };
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Mark property as sold",
              isOpen: props.isOpen,
              ariaLabel: "Mark property as sold",
              onDismiss: (function () {
                  close();
                }),
              size: "Large",
              children: JsxRuntime.jsx("form", {
                    children: JsxRuntime.jsxs(ViewStack.make, {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Once this property is marked as sold, it will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
                                }),
                            JsxRuntime.jsx(Form__Input.make, {
                                  labelText: "Sold price",
                                  optionalText: "optional",
                                  onChange: (function (evt) {
                                      var value = Form__Helpers.intFromFormattedPrice(evt);
                                      setSoldPrice(function (param) {
                                            return value;
                                          });
                                    }),
                                  prepend: "$",
                                  value: Form__Helpers.intOptToFormattedPrice(soldPrice)
                                }),
                            JsxRuntime.jsx(Form__Checkbox.make, {
                                  onChange: (function (param) {
                                      setHideSoldPrice(function (prev) {
                                            return !prev;
                                          });
                                    }),
                                  checked: hideSoldPrice,
                                  label: "Keep sold price private (only visible to you)",
                                  mobileStyles: true
                                }),
                            JsxRuntime.jsx(Form__TextAreaField.make, {
                                  labelText: "Comments",
                                  optionalText: "optional",
                                  onChange: (function (evt) {
                                      var value = evt.target.value;
                                      setComment(value);
                                    }),
                                  value: comment
                                }),
                            (function (__x) {
                                  return ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
                                                  children: "There was a problem updating the property. Please try again."
                                                }), __x);
                                })(submissionStatus === "SubmissionError"),
                            JsxRuntime.jsxs(ViewStack.make, {
                                  mt: "lg",
                                  space: "sm",
                                  justifyContent: "flexEnd",
                                  flexDirection: "row",
                                  children: [
                                    JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                          onClick: (function (param) {
                                              close();
                                            }),
                                          disabled: submissionStatus === "Loading",
                                          size: "medium",
                                          _type: "button",
                                          children: "Cancel"
                                        }),
                                    JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                          disabled: submissionStatus === "Loading",
                                          children: "Mark as sold"
                                        })
                                  ]
                                })
                          ]
                        }),
                    onSubmit: (function ($$event) {
                        $$event.preventDefault();
                        setSubmissionStatus(function (param) {
                              return "Loading";
                            });
                        mutate({
                              input: {
                                comments: Form__Helpers.opt_of_string(comment),
                                hideSoldPrice: hideSoldPrice,
                                id: propertyId,
                                soldPrice: Core__Option.map(soldPrice, Scalars.PriceInput.fromInt)
                              }
                            }, undefined, undefined, undefined, (function (param, param$1) {
                                var markForSalePropertySold = param.markForSalePropertySold;
                                if (markForSalePropertySold !== undefined) {
                                  if (markForSalePropertySold.__typename === "ForSalePropertyMarkedSold") {
                                    return handleMarkingSoldSuccess();
                                  } else {
                                    return setSubmissionStatus(function (param) {
                                                return "SubmissionError";
                                              });
                                  }
                                } else {
                                  return setSubmissionStatus(function (param) {
                                              return "SubmissionError";
                                            });
                                }
                              }), (function (param) {
                                setSubmissionStatus(function (param) {
                                      return "SubmissionError";
                                    });
                              }), undefined);
                      })
                  })
            });
}

var make = MarkPropertyAsSoldDialog;

exports.MarkPropertyAsSoldMutation = MarkPropertyAsSoldMutation;
exports.make = make;
/* commitMutation Not a pure module */
